
const BASE_PATH = 'RESET_PASSWORD';

export const SET_RESET_PASSWORD_DATA = `${BASE_PATH}/SET_RESET_PASSWORD_DATA`


export const setData = data => ({
    type: SET_RESET_PASSWORD_DATA,
    data
});


const initialState = {
    errorMessage: '',
    email: '',
    emailError: '',
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_RESET_PASSWORD_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        default:
            break;
    }

    return state;
}